import {CalculationTimeFrameType} from '@hconnect/common/types'

import {QuickSelectionId} from '../types'

// Due to performance reasons for selected slot we only ask for one time frames which comes from RTC
export const QuickSelectionIdsForSlotMap: Record<QuickSelectionId, QuickSelectionId[]> = {
  today: ['today', 'last7days', 'lastMonth'],
  yesterday: ['yesterday', 'last7days', 'lastMonth'],
  last7days: ['yesterday', 'last7days', 'lastMonth'],
  last3days: [],
  last30days: [],
  last3months: [],
  lastMonth: [],
  yearToMonthYTM: [],
  lastYear: [],
  currentMonth: [],
  yearToDateYTD: []
}

export const QuickSelectionIdsToCalculationTimeFrameTypeMap: Record<
  QuickSelectionId,
  CalculationTimeFrameType | undefined
> = {
  today: CalculationTimeFrameType.Today,
  yesterday: CalculationTimeFrameType.Yesterday,
  last3days: CalculationTimeFrameType.Last3Days,
  last7days: CalculationTimeFrameType.Last7Days,
  last30days: CalculationTimeFrameType.Last30Days,
  lastMonth: CalculationTimeFrameType.LastMonth,
  last3months: undefined,
  yearToMonthYTM: undefined,
  lastYear: undefined,
  currentMonth: undefined,
  yearToDateYTD: undefined
}
